module.exports = __webpack_public_path__ + "img/9791158881641.5138da66.jpg";